import {StyleSheet} from 'react-native';

import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  header: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  avatarWrapper: {
    width: '20%',
    aspectRatio: 1,
    marginRight: spacing.s,
    overflow: 'hidden',
  },
  avatar: {
    ...StyleSheet.absoluteFillObject,
  },
}));
